import { Api } from "../config/request";

// API function to create a session
const requestCreateSession = async () => {
    let response = await Api.PostRequest("session/createSession", {});
    return response.data;
};

const sessionApi = {
    requestCreateSession,
};

export default sessionApi;